(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/eurojackpot-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/eurojackpot-draw.js');

'use strict';

const _svs$numbergames$prod = svs.numbergames.productMapping.CONSTANTS,
  EUROJACKPOT = _svs$numbergames$prod.EUROJACKPOT,
  EUROJACKPOT_TUESDAY = _svs$numbergames$prod.EUROJACKPOT_TUESDAY,
  EUROJACKPOT_FRIDAY = _svs$numbergames$prod.EUROJACKPOT_FRIDAY;

class EurojackpotDraw extends svs.numbergames.draws.Draws {
  constructor() {
    super({
      productItsIds: [EUROJACKPOT_TUESDAY, EUROJACKPOT_FRIDAY]
    });
  }
  get product() {
    return EUROJACKPOT;
  }
}
svs.numbergames.draws.EurojackpotDraw = EurojackpotDraw;

 })(window);